/**
 * 다중 탭 간 인증 상태 동기화를 위한 BroadcastChannel 유틸리티
 */

// BroadcastChannel 인스턴스 (싱글톤)
let authChannel: BroadcastChannel | null = null;

// BroadcastChannel 초기화
export const initAuthChannel = (): BroadcastChannel => {
    if (!authChannel) {
        authChannel = new BroadcastChannel('auth-channel');
    }
    return authChannel;
};

// 메시지 타입 정의
export type AuthMessage = {
    type: 'logout';
    timestamp: number;
};

/**
 * 모든 탭에 로그아웃 메시지 전송
 */
export const broadcastLogout = (): void => {
    const channel = initAuthChannel();
    const message: AuthMessage = {
        type: 'logout',
        timestamp: Date.now(),
    };
    channel.postMessage(message);
};

/**
 * 로그아웃 메시지 리스너 등록
 * @param callback 로그아웃 메시지 수신 시 실행할 콜백
 * @returns cleanup 함수
 */
export const onLogoutBroadcast = (callback: () => void): (() => void) => {
    const channel = initAuthChannel();

    const handleMessage = (event: MessageEvent<AuthMessage>) => {
        if (event.data.type === 'logout') {
            callback();
        }
    };

    channel.addEventListener('message', handleMessage);

    // cleanup 함수 반환
    return () => {
        channel.removeEventListener('message', handleMessage);
    };
};

/**
 * BroadcastChannel 종료
 */
export const closeAuthChannel = (): void => {
    if (authChannel) {
        authChannel.close();
        authChannel = null;
    }
};
